// Build60 cadence, with a bounded unknown-error budget for HTML images.
// HTML img errors do not reliably distinguish a missing image from a network outage.
export const IMAGE_STALL_MS = 45000;
export const IMAGE_RETRY_DELAYS_MS = [1500, 4000, 10000, 30000, 60000];
export function createImageRecovery(reload, showFailure) {
  let attempt = 0;
  let failures = 0;
  let live = false;
  let active = false;
  let activated = false;
  let phase = 'loading';
  let timer;
  const clear = () => {
    clearTimeout(timer);
    timer = undefined;
  };
  const accepts = (token) => live && token === attempt;
  const watch = () => {
    clear();
    if (live && active && phase === 'loading')
      timer = setTimeout(() => fail(attempt), IMAGE_STALL_MS);
  };
  const retry = () => {
    clear();
    if (!live || !active || phase === 'loaded' || phase === 'terminal') return;
    phase = 'loading';
    reload(++attempt);
    watch();
  };
  const fail = (token, status) => {
    if (!accepts(token) || phase !== 'loading') return false;
    clear();
    phase = [400, 401, 403, 404, 405, 410, 422].includes(status) ? 'terminal' : 'waiting';
    showFailure?.();
    if (phase === 'waiting') {
      const delay = IMAGE_RETRY_DELAYS_MS[failures++];
      if (delay == null) phase = 'exhausted';
      else if (active) timer = setTimeout(retry, delay);
    }
    return true;
  };
  return {
    start(next) {
      live = true;
      active = next;
      activated ||= next;
      watch();
    },
    setActive(next) {
      if (!live || next === active) return;
      active = next;
      clear();
      if (active) {
        const firstActivation = !activated;
        activated = true;
        if (firstActivation && phase === 'loading') {
          watch();
          return;
        }
        failures = 0;
        retry();
      }
    },
    loaded(token) {
      if (!accepts(token) || phase === 'loaded' || phase === 'terminal') return false;
      phase = 'loaded';
      clear();
      return true;
    },
    failed: fail,
    dispose() {
      live = false;
      active = false;
      clear();
    },
  };
}
